export default __webpack_public_path__ + "static/media/pinkbg.a2f0854d.jpeg";